SP.lang.Class.define("SP.sitekit.form.validator.FileSize", {

	_options: null,

	init: function (options) {
		this._options = options;
	},

	isValid: function (value, el) {
		var file = el.files.length >= 1 ? el.files[0] : null;
		if (file !== null) {
			return file.size <= this._options.max;
		} else {
			return true;
		}
	},

	getMessage: function () {
		return this._options.messages.maxFileSize;
	}

});
